/**
 * NOTICE : This HOC will soon be deprecated.
 * You should not use this HOC for any future components.
 */

import * as React from "react";
import { StaticRouterProps } from "react-router";
import { BrowserRouter, StaticRouter, useLocation } from "react-router-dom";
import { PropsAreEqual } from ".";

const Debugger = () => {
  const location = useLocation();

  return <pre>{JSON.stringify(location)}</pre>;
};

type InjectedRouterProps = StaticRouterProps;

export const withInjectedRouter = <P extends object>(
  Component: React.ComponentType<P>,
  propsAreEqual?: PropsAreEqual<P & InjectedRouterProps> | false,
  componentName = Component.displayName ?? Component.name
) => {
  return (props: P & InjectedRouterProps): JSX.Element => {
    const { location, basename, context, ...rest } = props;

    React.useEffect(() => {
      console.warn(
        "[DEPRECATION NOTICE] withInjectedRouter will soon be deprecated next major. Avoid using this HOC."
      );
    }, []);

    const componentProps = rest as P;

    if (typeof window === "undefined") {
      return (
        <StaticRouter location={location} basename={basename} context={context}>
          {/* <Debugger /> */}
          <Component {...componentProps} />
        </StaticRouter>
      );
    }

    return (
      <BrowserRouter>
        <Component {...componentProps} />
      </BrowserRouter>
    );
  };
};
